import type { CommissionRuleGateway } from '@/application/port/out/CommissionRuleGateway';
import type { CommissionEntryGateway, ListCommissionEntriesParams } from '@/application/port/out/CommissionEntryGateway';
import type { CommissionRule, CommissionEntry, CommissionRuleCommand } from '@/domain/model/Commission';
import type { Page } from '@/domain/model/Page';
import type {
  ListCommissionRulesUseCase, GetCommissionRuleUseCase,
  CriarCommissionRuleUseCase, AtualizarCommissionRuleUseCase, DesativarCommissionRuleUseCase,
  ListCommissionEntriesUseCase, ApropriarCommissionEntryUseCase, PagarCommissionEntryUseCase,
} from '@/application/port/in/CommissionUseCase';

export class ListCommissionRules implements ListCommissionRulesUseCase {
  constructor(private readonly gw: CommissionRuleGateway) {}
  execute(p: { ativo?: boolean; page?: number; size?: number }): Promise<Page<CommissionRule>> { return this.gw.list(p); }
}
export class GetCommissionRule implements GetCommissionRuleUseCase {
  constructor(private readonly gw: CommissionRuleGateway) {}
  execute(id: string): Promise<CommissionRule> { return this.gw.get(id); }
}
export class CriarCommissionRule implements CriarCommissionRuleUseCase {
  constructor(private readonly gw: CommissionRuleGateway) {}
  execute(c: CommissionRuleCommand): Promise<CommissionRule> { return this.gw.criar(c); }
}
export class AtualizarCommissionRule implements AtualizarCommissionRuleUseCase {
  constructor(private readonly gw: CommissionRuleGateway) {}
  execute(id: string, c: CommissionRuleCommand): Promise<CommissionRule> { return this.gw.atualizar(id, c); }
}
export class DesativarCommissionRule implements DesativarCommissionRuleUseCase {
  constructor(private readonly gw: CommissionRuleGateway) {}
  execute(id: string): Promise<void> { return this.gw.desativar(id); }
}
export class ListCommissionEntries implements ListCommissionEntriesUseCase {
  constructor(private readonly gw: CommissionEntryGateway) {}
  execute(p: ListCommissionEntriesParams): Promise<Page<CommissionEntry>> { return this.gw.list(p); }
}
export class ApropriarCommissionEntry implements ApropriarCommissionEntryUseCase {
  constructor(private readonly gw: CommissionEntryGateway) {}
  execute(id: string): Promise<CommissionEntry> { return this.gw.apropriar(id); }
}
export class PagarCommissionEntry implements PagarCommissionEntryUseCase {
  constructor(private readonly gw: CommissionEntryGateway) {}
  execute(id: string): Promise<CommissionEntry> { return this.gw.pagar(id); }
}
